<app-breadcrumb  [master]="'OCK'" [parentName]="'Import'" [name]="'Dodaj VIN'"></app-breadcrumb>
<div class="vin-add-container" fxLayout="column" fxLayoutGap="15px"  >
  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px" >
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!formValid  ||processingRequest" [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz</span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>

  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
      <div fxFlex="100" fxFlex.lt-md="100" fxLayoutGap="15px">
        <mat-card>
          <div fxLayout="row" >
            <h3>Dodawanie VIN</h3>
          </div>


          <div fxLayout="row" fxLayoutGap="15px">

            <div fxFlex="100">
              <mat-form-field fxFlex="100">
                <mat-label>VIN</mat-label>

                <input [formControl]="valueControl" appCapitalizeFirst matInput placeholder="VIN"  [required]="true" >

              </mat-form-field>
            </div>
          </div>

        </mat-card>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxFlex="100" fxLayoutGap="15px">
    <button (click)="sendForm()" mat-stroked-button color="primary" [disabled]="!formValid ||processingRequest " [class.spinner]="processingRequest">
      <mat-icon>save</mat-icon> <span> Zapisz </span></button>
    <button (click)="cancel()" mat-stroked-button color="warn"><mat-icon>cancel</mat-icon> <span> Anuluj</span></button>
  </div>
</div>

